import React from 'react';
import { List, ListItem } from 'material-ui/List';

class MenuLeft extends React.Component {


    render() {

        return (
            <div style={{ backgroundColor: '#ffffff' }}>
{/*                 <List>
                    <ListItem primaryText="Institucional" href="institucional" />
                    <ListItem primaryText="História" href="historia" />
                    <ListItem primaryText="Governança" href="governanca"/>
                    <ListItem primaryText="Transparência" href="transparencia" />
                    <ListItem primaryText="Relatório IDSS" href="idss" />
                </List> 
 */}

                <List subheader="Item Requests">
                    <ListItem primaryText="Institucional" href="institucional" />
                    <ListItem primaryText="História" href="historia" />
                    <ListItem
                        primaryText="Governança e Compliance"
                        primaryTogglesNestedList={true}
                       // open={true}
                        nestedItems={[
                            <ListItem
                                key={1}
                                primaryText="Compliance" href="compliance"
                            />,
                            <ListItem
                                key={2}
                                primaryText="Relatório de Gestão e Sustentabilidade" href="transparencia"
                            />,
                        ]}
                    />
                    <ListItem primaryText="Relatório IDSS" href="idss" />                
              </List>  
            </div>
        );

    }


}

export default MenuLeft;



/** WEBPACK FOOTER **
 ** ./src/components/Sidebar/MenuLeft.js
 **/